function toFixedFloatNumberUtil (value, fractionDigits = 1) {
  if (!value) {
    return 0
  }
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  if (!value.toString().includes('.')) {
    return value
  }
  return parseFloat(value.toFixed(fractionDigits))
}

export {
  toFixedFloatNumberUtil
}
